import { clearClaimQuestions, getClaimQuestions } from '../actions/claims';

const initialState = {
  data: {},
  loading: false,
  error: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case clearClaimQuestions.TRIGGER:
      return { ...initialState };

    case getClaimQuestions.TRIGGER:
      return { ...state, loading: true };

    case getClaimQuestions.REQUEST:
      return { ...state, error: null };

    case getClaimQuestions.SUCCESS: {
      const { id: claimSelectorID, ...rest } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          [claimSelectorID]: {
            id: claimSelectorID,
            ...rest,
          },
        },
      };
    }

    case getClaimQuestions.FAILURE:
      return { ...state, error: action.payload };

    case getClaimQuestions.FULFILL:
      return { ...state, loading: false };

    default:
      return state;
  }
};
